module.exports = __webpack_public_path__ + "img/agriculture/square_icon7.b62be0a5.png";